<template>
    <section class="gradient-custom">
        <div class="container my-5">
            <img v-bind:src="require('@/assets/logo_dark.png')" alt="Responsive image" style="width: 200px;">
            <div class="row d-flex justify-content-center py-4">
                <div class="col-md-10 col-lg-8 col-xl-7">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <h5 class="card-title">Buy Subscription</h5>
                            <h6 align="left" class="card-title" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default">Nickname</h6>
                            <p id="typeName" class="form-control form-control-lg input-pill input-readonly" siez="17" aria-label="Default"
                                aria-describedby="inputGroup-sizing-default" align="left">{{ userP }}</p>
                            <br>
                            <p for="disabledSelect" class="form-label" align="left">Choose a subscription and enjoy
                                true privacy</p>
                            <div class="pricing-grid">
                                <div v-for="sub in subscribed" :key="sub.id"
                                    :class="['pricing-card', { recommended: sub.isRecommended, selected: select === sub.id }]"
                                    @click="select = sub.id">
                                    <div v-if="sub.isRecommended" class="recommended-badge">RECOMMENDED</div>
                                    <div class="plan-name">{{ sub.displayName }}</div>
                                    <div class="plan-price">USD {{ sub.priceFormatted }}</div>
                                    <div class="plan-price-period">{{ sub.period }}</div>
                                    <div class="plan-referral" v-if="!sub.isLifetime">
                                        Using the Nickname of 1 user from NN: You will get <strong>USD {{
                                            sub.referralDiscount }} -OFF-</strong>
                                        <span class="discount">USD {{ sub.discountedPriceFormatted }}</span>
                                        And that user will earn:
                                        <span class="reward">USD {{ sub.referralReward }} Reward</span>
                                    </div>
                                    <div class="plan-referral" v-else>
                                        Using the Nickname of 1 user from NN, your referred will earn:
                                        <span class="reward" style="font-size:22px;">USD {{ sub.referralReward }}
                                            Reward</span>
                                    </div>
                                    <div class="plan-label">Benefits:</div>
                                    <ul class="plan-benefits">
                                        <li v-for="benefit in sub.benefits" :key="benefit">{{ benefit }}</li>
                                    </ul>
                                </div>
                            </div>
                            <br>
                            <p for="disabledSelect" class="form-label" align="left">Referred? Enter the nickname of
                                your contact to get a discount.</p>
                            <input type="text" id="typeName" :maxlength="max" class="form-control form-control-lg input-pill"
                                siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                v-model="referido">
                            <p v-if="referido != null && referido.length > 3 && referido != userP" align="left"
                                class="my-3 mb-2 fw-bold">The user {{ referido }} will receive 4 to 100 USD reward
                                depending on the selected subscription.</p>
                            <br v-if="referido == null || referido.length <= 3 || referido == userP">
                            <h5 align="left">Total to pay: <span class="fw-blod">{{ formatAmount(amount) }} USD</span>
                            </h5>
                            <p align="left">*By pressing the pay button, you are accepting the
                                <a href="https://napoleon.chat/terminos-condiciones" target=“_blank”
                                    style="color:#d7a952;">terms and conditions </a>
                            </p>
                            <div
                                class="col-md-12 d-flex flex-column flex-md-row justify-content-center align-items-center">
                                <a href="https://napoleon.chat/" type="button"
                                    class="btn btn-outline-dark mx-2 my-2 px-4 py-2 fw-bold btn-cancel w-100 w-md-auto order-2 order-md-0">Cancel</a>
                                <button type="button" class="btn mx-2 my-2 px-5 py-2 fw-bold btn-cta btn-subscribe w-100 w-md-auto order-0 order-md-1"
                                    v-on:click="paySub(false)">Subscribe Now</button>
                                <button type="button" class="btn mx-2 my-2 px-4 py-2 fw-bold btn-crypto w-100 w-md-auto order-1 order-md-2"
                                    v-on:click="paySub(true)"><span style="display:inline-flex;align-items:center;gap:6px;"><img src="https://upload.wikimedia.org/wikipedia/commons/0/01/USDT_Logo.png" alt="USDT" style="width:18px;height:18px;">Pay with Crypto</span></button>
                            </div>
                            <p class="text-center mt-3 mb-0" style="font-size: 12px; color: rgba(0,0,0,0.35);">
                                🔒 Secure payment &nbsp;·&nbsp; No hidden fees
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import 'vue-loading-overlay/dist/css/index.css';
import { mapState } from 'vuex';
import { getSubsV6 } from '@/modules/subscriptions/aplication/getSubs';
import { SubscriptionRepository } from '@/modules/subscriptions/infraestructure/SubscriptionRepository';
import store from '@/store';
import { postPaymentV8 } from '@/modules/payments/aplication/postPayment';
import { PaymentRepository } from '@/modules/payments/infraestructure/PaymentRepository';
import { postPaymentUsdtV8 } from '@/modules/payments/aplication/postPaymentUsdt';
import { IpregistryClient } from '@ipregistry/client';
import { getEnv } from '@/config/config';

const PLAN_CONFIG = {
    mensual: {
        displayName: 'Month',
        period: '/ month',
        isRecommended: false,
        isLifetime: false,
        referralDiscount: 2,
        referralReward: 4,
        benefits: [
            "You will be able to use the app without limits or restrictions in all its features (Excepted the Security Vault that will be available only for VIP users).",
            "Top Grade Security",
            "Regular updates",
        ]
    },
    anual: {
        displayName: 'Annual',
        period: '/ annual',
        isRecommended: true,
        isLifetime: false,
        referralDiscount: 5,
        referralReward: 10,
        benefits: [
            "Make only one payment for the entire year.",
            "Security Vault with no self-destruct.",
            "Personalized attention from the NapoleoN Team.",
        ]
    },
    vip: {
        displayName: 'LifeTime VIP',
        period: '/ forever VIP',
        isRecommended: false,
        isLifetime: true,
        referralReward: 100,
        benefits: [
            "Option to buy a special nickname without a number. (Optional, with cost). Example: @superman @dubai @maria",
            "Security Vault with no self-destruct.",
            "Access to meetings and private events with the NapoleoN Team and its executives.",
            "Personalized advice from the CEO of NN Chat."
        ]
    }
}

export default {
    name: "UnsubscribedComponent",
    data() {
        return {
            amount: 0,
            subscribed: [],
            userP: "",
            select: 0,
            referido: null,
            max: 20,
            euro: false,
        }
    },
    watch: {
        referido: function () {
            if (this.referido && this.referido.length >= 3) {
                this.valueDiscount()
            } else {
                const sub = this.subscribed.find(sub => sub.id === this.select)
                if (sub) this.amount = sub.price
            }
        },
        select: function () {
            const sub = this.subscribed.find(sub => sub.id === this.select);
            if (sub) {
                if (this.referido != null && this.referido.length > 3) {
                    return this.valueDiscount()
                }
                this.amount = sub.price
            }
        }
    },
    computed: mapState(['user', 'load']),
    mounted() {
        this.detectEuroZone()
        this.consultUser()
        this.fetchSubscriptions()
    },
    methods: {
        async consultUser() {
            if (this.user.id == 0) {
                this.$router.push({ name: 'search' })
                return
            }
            this.userP = this.user.nick
        },

        async fetchSubscriptions() {
            const data = await getSubsV6(SubscriptionRepository(), this.euro.toString())
            if (!data) {
                store.commit('setLoad', false)
                return
            }
            this.chargeMoney(data)
        },

        chargeMoney(apiData) {
            const order = { mensual: 0, anual: 1, vip: 2 }
            const enriched = apiData
                .filter(item => PLAN_CONFIG[item.name.toLowerCase()])
                .map(item => {
                    const name = item.name.toLowerCase()
                    const config = PLAN_CONFIG[name]
                    const price = parseFloat(item.price)
                    const discountedPrice = config.isLifetime ? price : price - config.referralDiscount
                    return {
                        id: item.id,
                        name: item.name,
                        displayName: config.displayName,
                        period: config.period,
                        price: price,
                        valueOriginal: item.price,
                        priceFormatted: price.toFixed(2).replace('.', ','),
                        discountedPriceFormatted: discountedPrice.toFixed(2).replace('.', ','),
                        isRecommended: config.isRecommended,
                        isLifetime: config.isLifetime,
                        referralDiscount: config.referralDiscount || 0,
                        referralReward: config.referralReward || 0,
                        benefits: config.benefits,
                    }
                })
                .sort((a, b) => order[a.name] - order[b.name])
            this.subscribed = enriched
            if (this.subscribed.length > 0) {
                this.select = this.subscribed[0].id
                this.amount = this.subscribed[0].price
            }
            store.commit('setLoad', false)
        },

        valueDiscount() {
            if (this.referido != null && this.referido.length > 3) {
                const sub = this.subscribed.find(sub => sub.id === this.select);
                if (sub) {
                    let discount = 100;
                    if (sub.name == "mensual") {
                        discount = 2
                    } else if (sub.name == "anual") {
                        discount = 5
                    } else {
                        return this.amount = sub.price
                    }
                    const price = parseFloat(sub.valueOriginal);
                    const newPrice = (price - discount)
                    this.amount = newPrice;
                }
            }
        },

        async paySub(isUsdt = false) {
            store.commit('setLoad', true)
            const sub = this.subscribed.find(sub => sub.id === this.select);
            const body = {
                nick: this.userP,
                sub: sub.name,
                nick_or_referred_code: this.referido ? this.referido.toLowerCase() : null,
                euro: this.euro.toString()
            };
            let data = null;
            if (isUsdt) {
                data = await postPaymentUsdtV8(PaymentRepository(), body)
            }
            if (!isUsdt) {
                data = await postPaymentV8(PaymentRepository(), body)
            }
            if (data == null) {
                store.commit('setLoad', false)
                return
            }
            window.location.href = data.link;
        },

        capitalizeFirstLetter(text) {
            if (!text) return '';
            return text.charAt(0).toUpperCase() + text.slice(1);
        },

        formatAmount(value) {
            if (Number.isInteger(value) || value % 1 === 0) return value.toString()
            return value.toFixed(2)
        },

        async detectEuroZone() {
            try {
                const client = new IpregistryClient(getEnv('VUE_APP_IPREGISTRY_KEY'))
                const result = await client.originLookupIp()
                this.euro = result.data?.currency?.code === 'EUR'
            } catch (error) {
                console.error('Error detecting location:', error)
                this.euro = false
            }
        },
    },
}
</script>

<style scoped>
.pricing-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 16px;
}

.pricing-card {
    background: rgba(255, 255, 255, 0.95);
    border: 2px solid rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    padding: 24px 16px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
}

.pricing-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
}

.pricing-card.selected {
    border-color: #d7a952;
    box-shadow: 0 0 0 1px #d7a952, 0 8px 24px rgba(215, 169, 82, 0.15);
}

.pricing-card.recommended {
    border-color: rgba(215, 169, 82, 0.4);
}

.recommended-badge {
    position: absolute;
    top: -11px;
    left: 50%;
    transform: translateX(-50%);
    background: #d7a952;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 3px 14px;
    border-radius: 100px;
    white-space: nowrap;
}

.plan-name {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 12px;
}

.plan-price {
    font-size: 36px;
    font-weight: 700;
    color: #212529;
    line-height: 1;
    margin-bottom: 4px;
}

.plan-price-period {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.4);
    font-weight: 400;
    margin-bottom: 16px;
}

.plan-referral {
    background: rgba(215, 169, 82, 0.08);
    border: 1px solid rgba(215, 169, 82, 0.15);
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 16px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.55);
    line-height: 1.6;
}

.plan-referral .discount {
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    display: block;
    margin: 3px 0;
}

.plan-referral .reward {
    font-size: 15px;
    font-weight: 700;
    color: #d7a952;
    display: block;
    margin-top: 3px;
}

.plan-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: rgba(0, 0, 0, 0.3);
    margin-bottom: 10px;
    padding-top: 4px;
}

.plan-benefits {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
    margin: 0;
    text-align: left;
}

.plan-benefits li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.55);
    line-height: 1.4;
}

.plan-benefits li::before {
    content: '✓';
    color: #d7a952;
    font-weight: 700;
    flex-shrink: 0;
    margin-top: 1px;
}

@keyframes ctaPulse {
    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(215, 169, 82, 0.4);
    }

    50% {
        box-shadow: 0 0 0 10px rgba(215, 169, 82, 0);
    }
}

.btn-cta {
    animation: ctaPulse 3s infinite;
    transition: all 0.25s ease;
}

.btn-cta:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 24px rgba(215, 169, 82, 0.35);
}

.btn-subscribe {
    background: linear-gradient(135deg, #d7a952, #e8b84b);
    color: #fff;
    border: none;
    border-radius: 50px;
    box-shadow: 0 4px 20px rgba(215, 169, 82, 0.2);
    font-size: 16px;
}

.btn-subscribe:hover {
    background: linear-gradient(135deg, #c9983a, #d7a952);
}

@keyframes arrowBounce {
    0%, 100% { transform: translateX(0); }
    50%      { transform: translateX(4px); }
}

.btn-cta::after {
    content: ' →';
    display: inline-block;
    animation: arrowBounce 1.5s ease-in-out infinite;
}

.btn-cancel {
    border-radius: 50px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    font-size: 14px;
    transition: all 0.25s ease;
}

.btn-cancel:hover {
    background: linear-gradient(135deg, #555, #777);
    transform: scale(1.03);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
    color: #fff;
}

.btn-crypto {
    background: linear-gradient(135deg, #1a1a1a, #333);
    color: #fff;
    border: none;
    border-radius: 50px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    font-size: 14px;
    transition: all 0.25s ease;
}

.btn-crypto:hover {
    background: linear-gradient(135deg, #333, #555);
    transform: scale(1.05);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.input-pill {
    border-radius: 50px;
    border: 2px solid rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.95);
    transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.input-pill:focus {
    border-color: #d7a952;
    box-shadow: 0 0 0 3px rgba(215, 169, 82, 0.1);
    outline: none;
}

.input-readonly {
    background: rgba(215, 169, 82, 0.05);
    border-color: rgba(215, 169, 82, 0.15);
    color: #495057;
}

@media (max-width: 991px) {
    .pricing-grid {
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .pricing-card {
        padding: 20px 14px;
    }

    .plan-price {
        font-size: 30px;
    }

    .plan-referral {
        font-size: 11px;
        padding: 10px 12px;
    }

    .plan-referral .discount {
        font-size: 16px;
    }

    .plan-referral .reward {
        font-size: 14px;
    }

    .plan-benefits li {
        font-size: 11px;
    }

    .btn-cta {
        animation: none;
    }
}
</style>